import {Entity} from '../../core/commons/entity';
import {FormViewField} from './form-view-field';
import { FormViewData } from './form-view-data';


export class FormViewFieldData implements Entity {
    id: number;
    value: string;
    field: FormViewField;
    parentViewData: FormViewData;

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.field) {
            this.field = new FormViewField(this.field);
        }
    }

    replaceText(text: string) {
        this.value = this.field.placeholder.replace('{@}', text);
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/domain/form-view-field-data.ts